import React, { useEffect, useState } from "react";
import { Table, Select, Card, Button, DatePicker, Space } from "antd";
import { ApiURL, baseURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast"; 
import { formatDate } from "../../../utils/dateFormatter";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const InvoiceManagement = () => {
  const [loading, setLoading] = useState(false);

  const [company_id, set_company_id] = useState(null);
  const [company_list, set_company_list] = useState([]);

  const [ship_id, set_ship_id] = useState([]);
  const [ship_list, set_ship_list] = useState([]);

  const [dateRange, setDateRange] = useState([]);

  const [invoiceList, setInvoiceList] = useState([]);

  /* ---------------- COMPANY LIST API ---------------- */
  const COMPANY_LIST_API = () => {
    post(ApiURL.all_company_lising, new FormData()).then((res) => {
      if (res?.status) {
        set_company_list(res.data || []);
      }
    });
  };

  /* ---------------- SHIP LIST API ---------------- */
  const SHIP_LIST_API = (companyId) => {
    const fd = new FormData();
    fd.append("company_id", companyId);

    post(ApiURL.get_ships_by_company, fd).then((res) => {
      if (res?.status) {
        set_ship_list(res.ships || []);
        set_ship_id([]); // reset ship filter on company change
      }
    });
  };

  /* ---------------- INVOICE LIST API ---------------- */
  const INVOICE_LIST_API = () => {
    setLoading(true);

    const fd = new FormData();

    if (company_id) fd.append("company_id", company_id);

    if (ship_id?.length > 0) {
      ship_id.forEach((id) => fd.append("ship_id[]", id));
    }

    if (dateRange?.length === 2) {
      fd.append("from_date", dateRange[0]);
      fd.append("to_date", dateRange[1]);
    }

    post(ApiURL.invoice_list_admin, fd)
      .then((res) => {
        if (res?.status) {
          setInvoiceList(res.data || []);
        } else {
          ErrorToast("Error", res.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    COMPANY_LIST_API();
    INVOICE_LIST_API(); 
  }, []);


  useEffect(() => {
    if (company_id) {
      SHIP_LIST_API(company_id);
    } else {
      set_ship_list([]);
      set_ship_id([]);
    }
  }, [company_id]);

 
const handlePreview = (invoiceId) => {
  const url = `${baseURL}/admin-api/invoice-preview-by-id/${invoiceId}/`;
  window.open(url, "_blank");
};

const handleDownload = (invoiceId) => {
  const url = `${baseURL}/admin-api/invoice-download-by-id/${invoiceId}/`;
  window.open(url, "_blank");
};


  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "invoice_id",
      align: "center",
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
    },
    {
  title: "Ship(s)",
  dataIndex: "ships",
  align: "center",
  render: (ships) =>
    ships?.length
      ? ships.map((s) => s.vessel_name).join(", ")
      : "-",
},
    {
      title: "Generated Date",
      dataIndex: "generated_at",
      align: "center",
      render: (date) => formatDate(date),
    },
{
  title: "Actions",
  align: "center",
  render: (_, record) => (
    <Space>
      <Button
        type="primary"
        danger
        size="small"
        onClick={() => handlePreview(record.invoice_id)}
      >
        Preview
      </Button>

      <Button
        type="primary"
        danger
        size="small"
        onClick={() => handleDownload(record.invoice_id)}
      >
        Download
      </Button>
    </Space>
  ),
}

 
  ];

  return (
    <div style={{ padding: 10 }}>
      {/* ---------------- FILTER SECTION ---------------- */}
      <Card style={{ marginBottom: 20 }}>
        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "flex-end",
          }}
        >
          {/* Company */}
          <div style={{ flex: 1 }}>
            <label>Company</label>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Company"
              value={company_id}
              onChange={(value) => set_company_id(value)}
              allowClear
            >
              {company_list.map((c) => (
                <Select.Option key={c.id} value={c.id}>
                  {c.company_name}
                </Select.Option>
              ))}
            </Select>
          </div>

          {/* Ships */}
          <div style={{ flex: 1 }}>
            <label>Ships</label>
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              placeholder="Select Ships"
              value={ship_id}
              onChange={(value) => set_ship_id(value)}
              disabled={!company_id}
            >
              {ship_list.map(
                (ship) =>
                  !ship.soft_delete && (
                    <Select.Option key={ship.id} value={ship.id}>
                      {ship.vessel_name}
                    </Select.Option>
                  )
              )}
            </Select>
          </div>

          {/* Date Range */}
          <div style={{ flex: 1.5 }}>
            <label>Date Range</label>
            <RangePicker
              style={{ width: "100%" }}
              onChange={(dates) => {
                if (!dates) {
                  setDateRange([]);
                } else {
                  setDateRange([
                    dayjs(dates[0]).format("YYYY-MM-DD"),
                    dayjs(dates[1]).format("YYYY-MM-DD"),
                  ]);
                }
              }}
            />
          </div>

          {/* Apply Filters */}
          <Button
            type="primary"
            style={{ height: 40 }}
            onClick={INVOICE_LIST_API}
          >
            Apply Filters
          </Button>
        </div>
      </Card>

      {/* ---------------- TABLE ---------------- */}
      <Table
        bordered
        columns={columns}
        dataSource={invoiceList}
        loading={loading}
        rowKey="invoice_id"
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default InvoiceManagement;
